import React, { useRef, useState } from 'react';
import * as PropTypes from 'prop-types';

import S from './checkbox-dropdown.module.scss';
import { CheckBoxList } from '../../checkbox-list';
import { useOutsideClick } from '../../../../helpers/hooks/use-outside-click';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

const CheckBoxDropDown = ({ placeholder, list, name, disabled, handleChange, selected }) => {
  const SELECT_REF = useRef();
  const [isOpen, setIsOpen] = useState(false);
  useOutsideClick(SELECT_REF, () => setIsOpen(false));
  const { t } = useTranslation();

  const handleOnClick = () => {
    if (disabled) return;
    setIsOpen(!isOpen);
  };

  return (
    <div
      className={classNames(S.checkboxDropDown, { [S.active]: isOpen, [S.disabled]: disabled })}
      ref={SELECT_REF}
      onClick={handleOnClick}
    >
      <button type='button' disabled={disabled}>
        {placeholder
          ? `${selected.length === 0 ? t('common.all') : selected.length} ${placeholder.toLowerCase()}`
          : `${selected.length} ${t('common.selected')}`}
      </button>
      {isOpen && <CheckBoxList list={list} handleChange={handleChange} name={name} selected={selected} />}
    </div>
  );
};

CheckBoxDropDown.displayName = 'CheckBoxDropDown';
CheckBoxDropDown.propTypes = {
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  selected: PropTypes.array.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,

  handleChange: PropTypes.func.isRequired,
};

CheckBoxDropDown.defaultProps = {
  disabled: false,
  placeholder: null,
};

export { CheckBoxDropDown };
